import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import { Close } from '@mui/icons-material';
import Snackbar from '@mui/material/Snackbar';

const mapState = ({ snackbarOpen }) => ({ snackbarOpen });

export const SnackbarAlert = () => {
    const { snackbarOpen } = useSelector(mapState);
    const dispatch = useDispatch();

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        dispatch({
            type: 'CLOSE_SNACKBAR',
        });
    };

    return (
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
        }}
          open={snackbarOpen.open}
          autoHideDuration={6000}
          onClose={handleClose}
          message={snackbarOpen.message}
          action={[
                <IconButton key="close" size="small" aria-label="close" color="inherit" onClick={handleClose}>
                    <Close fontSize="small" />
                </IconButton>,
            ]}
        />
    );
};
